import router from "@/router";
import store from "@/state/store";

// Single source of truth for "this session is no longer valid". Invoked by the
// 401 response interceptor (the server rejected the token) and by the
// client-side inactivity timer. Clears all auth state and sends the user to
// /login exactly once, no matter how many concurrent requests 401 at the same
// time. Runs imperatively so it does not depend on any modal/component being
// mounted or reactive.
let expiring = false;

export function expireSession() {
  if (expiring) return;
  expiring = true;

  localStorage.removeItem("jwt");
  localStorage.removeItem("user");
  store.commit("auth/SET_CURRENT_USER", null);

  const current = router.currentRoute.value;
  if (current.name === "login") {
    expiring = false; // already there — nothing to redirect
    return;
  }

  router
    .push({ name: "login", query: { redirectFrom: current.fullPath } })
    .catch(() => {})
    .finally(() => {
      expiring = false;
    });
}
